import React, { useState, useEffect } from 'react';
import { useAudio } from '../contexts/AudioContext';
import '../styles/AudioControls.css';

const AudioControls = () => {
  const { 
    isMusicPlaying, 
    toggleMusic, 
    isMuted,
    toggleMute,
    volume, 
    adjustVolume,
    playSound,
    isAudioInitialized,
    audioReady
  } = useAudio();
  
  const [showVolumeSlider, setShowVolumeSlider] = useState(false);
  const [audioFailed, setAudioFailed] = useState(false);

  // Detectar si el audio no se ha inicializado después de un tiempo
  useEffect(() => {
    const checkAudioStatus = setTimeout(() => {
      if (!isMusicPlaying && isAudioInitialized === false) {
        setAudioFailed(true);
      }
    }, 5000);
    
    return () => clearTimeout(checkAudioStatus);
  }, [isMusicPlaying, isAudioInitialized]);

  const handleVolumeChange = (e) => {
    const newVolume = parseFloat(e.target.value);
    adjustVolume(newVolume);
  };

  const handleToggleMusic = () => {
    try {
      playSound('button_click');
    } catch (error) {
      console.warn('Error al reproducir sonido de botón:', error);
    }
    toggleMusic();
  };

  const handleToggleMute = () => {
    try {
      playSound('button_click');
    } catch (error) {
      console.warn('Error al reproducir sonido de botón:', error);
    }
    toggleMute();
  };
  
  const handleVolumeClick = () => {
    setShowVolumeSlider(!showVolumeSlider);
  };
  
  const handleManualAudioStart = () => {
    console.log('Activación manual de audio solicitada desde AudioControls');
    // Crear un contexto de audio temporal para forzar la activación
    try {
      const audioContext = new (window.AudioContext || window.webkitAudioContext)();
      audioContext.resume().then(() => {
        console.log('Contexto de audio activado manualmente');
        toggleMusic();
      });
    } catch (error) {
      console.error('Error al crear contexto de audio temporal:', error);
    }
  };

  return (
    <div className="audio-controls">
      <button 
        className={`audio-button ${isMusicPlaying ? 'active' : ''}`}
        onClick={handleToggleMusic}
        aria-label={isMusicPlaying ? "Pausar música" : "Reproducir música"}
        title={isMusicPlaying ? "Pausar música" : "Reproducir música"}
      >
        {isMusicPlaying ? "🔊" : "🔈"}
      </button>
      
      <button 
        className={`audio-button ${isMuted ? 'muted' : ''}`}
        onClick={handleToggleMute}
        aria-label={isMuted ? "Activar sonido" : "Silenciar"}
        title={isMuted ? "Activar sonido" : "Silenciar"}
      >
        {isMuted ? "🔇" : "🔉"}
      </button>
      
      {showVolumeSlider && (
        <div className="volume-slider">
          <input
            type="range"
            min="0"
            max="1"
            step="0.1"
            value={volume}
            onChange={handleVolumeChange}
            aria-label="Control de volumen"
            title="Control de volumen"
          />
        </div>
      )}
      
      <button 
        className="audio-button"
        onClick={handleVolumeClick}
        aria-label="Ajustar volumen"
        title="Ajustar volumen"
      >
        🔧
      </button>
      
      {audioFailed && (
        <button 
          className="audio-button btn-audio-fix"
          onClick={handleManualAudioStart}
          aria-label="Activar audio manualmente"
          title="Activar audio manualmente"
        >
          🔄
        </button>
      )}
    </div>
  );
};

export default AudioControls;
